import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import { Paginate, responseArray, responseObj } from '../nest-model/nest-model';
import { FormDataUpload } from './../nest-api';

/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HolidayApiProvider {
  model: string = 'attendances';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {

  }

  getHoliday(formData: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "getHoliday";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    if (typeof formData.page !== 'undefined' && formData.page !== null) urlParams.page = formData.page;
    if (typeof formData.limit !== 'undefined' && formData.limit !== null) urlParams.limit = formData.limit;

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, null);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  findAllLocation(companyId: number) {
    const method: string = "POST";
    const model: string = "teomworklocation";
    const func: string = "findAllLocation";
    const params: any = { companyId: companyId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, null);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  addHoliday(formData: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "addHoliday";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, null);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  editHoliday(formData: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "editHoliday";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, null);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  deleteHoliday(seqId: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "deleteHoliday";
    const params: any = { seqId: seqId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, null);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  downloadTemplateHoliday() {
    const method: string = 'GET';
    const func: string = 'downloadTemplateHoliday';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApi.urlBuilder(method, this.model, func, params, urlParams, null);
    return this.nestApi.requestBlob(method, url, func, params, body);
  }

  uploadHoliday(file: any, originalName) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "uploadHoliday";
    const params: FormDataUpload[] = [
      {
        name: 'file',
        value: file,
        fileName: originalName
      }
    ];
    const urlParams: any = {};;

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, null);
    return this.nestApi.requestUpload(method, url, params);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/attendance/holiday-api.ts